import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import EditMessage from './components/EditMessage'
import ViewMessage from './components/ViewMessage'
import styles from './styles.module.scss'
import ReplyingToMessage from 'srcReact/MessengerPage/components/ReplyingToMessage'

export default function Message({
  messageProp,
  containerCss,
  user,
  appendToPrevious,
  isLastMessage,
  isFirstMessage,
  lastMessageRef,
  firstMessageRef,
  deleteMessagePopin,
  showUserModal,
  showImageModal,
  setEditMode,
  unsetEditMode,
  editModeMessage,
  emojiPickerForMessage,
  setEmojiPickerForMessage,
  unsetEmojiPickerForMessage,
  showTime,
  messageTime,
  isMobile,
  isDesktop,
  isSender,
  selectedMessage,
  setSelectedMessage,
  isFileProcessing,
  targetRefs,
  scrollToTarget,
  fromQuickMessenger
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    messenger: { openedConversation }
  } = useSelector((state) => state)

  return editModeMessage && editModeMessage.id === messageProp.id ? (
    appendToPrevious ? (
      <EditMessage
        messageProp={messageProp}
        user={user}
        editModeMessage={editModeMessage}
        unsetEditMode={unsetEditMode}
        isMessageAppended={true}
      />
    ) : (
      <div className={`${styles.container} ${containerCss}`}>
        <Avatar
          containerCSS={styles.avatarContainer}
          imgWrapperSize='small'
          userId={user.id}
          profilePicture={user.profile_picture_url}
          firstname={user.firstname}
          lastname={user.lastname}
          onClickAction={() => showUserModal(user)}
          showImageAsDecorative={true}
          mimeType={user.mime_type}
          originalTag={user.original_tag}
          isOriginal={user.is_original}
          userStatus={user.status}
          withExpertiseGroup={user.with_expertise_group}
        />
        <div className={styles.content}>
          <p className={styles.userName}>{`${user.firstname} ${user.lastname}`}</p>
          <EditMessage
            messageProp={messageProp}
            user={user}
            editModeMessage={editModeMessage}
            unsetEditMode={unsetEditMode}
            isMessageAppended={false}
          />
        </div>
      </div>
    )
  ) : appendToPrevious ? (
    <ViewMessage
      messageProp={messageProp}
      user={user}
      appendToPrevious={appendToPrevious}
      isLastMessage={isLastMessage}
      isFirstMessage={isFirstMessage}
      lastMessageRef={lastMessageRef}
      firstMessageRef={firstMessageRef}
      setEditMode={setEditMode}
      isMessageAppended={true}
      deleteMessagePopin={deleteMessagePopin}
      showImageModal={showImageModal}
      isNonEmojiPickerMessage={emojiPickerForMessage && emojiPickerForMessage.id !== messageProp.id ? true : false}
      isEmojiPickerOpen={emojiPickerForMessage !== null}
      setEmojiPickerForMessage={setEmojiPickerForMessage}
      unsetEmojiPickerForMessage={unsetEmojiPickerForMessage}
      showTime={showTime}
      messageTime={messageTime}
      isMobile={isMobile}
      isDesktop={isDesktop}
      showUserModal={showUserModal}
      selectedMessage={selectedMessage}
      setSelectedMessage={setSelectedMessage}
      isSender={isSender}
      isFileProcessing={isFileProcessing}
      targetRefs={targetRefs}
      scrollToTarget={scrollToTarget}
      fromQuickMessenger={fromQuickMessenger}
    />
  ) : (
    <div
      className={`${styles.container} ${containerCss} ${
        messageProp.origin_message && messageProp.has_been_deleted !== 1
          ? styles.changedMessageWithReply
          : styles.changedMessage
      } ${
        openedConversation &&
        openedConversation.conversation.is_group_conversation == 1 &&
        !isSender &&
        styles.changedMessageWithGroup
      }`}>
      {openedConversation && openedConversation.conversation.is_group_conversation == 1 && user && !isSender && (
        <Avatar
          containerCSS={styles.avatarContainer}
          imgWrapperSize='small50'
          userId={user.id}
          profilePicture={user.profile_picture_url}
          firstname={user.firstname}
          lastname={user.lastname}
          onClickAction={() => showUserModal(user)}
          showImageAsDecorative={true}
          mimeType={user.mime_type}
          originalTag={user.original_tag}
          isOriginal={user.is_original}
          userStatus={user.status}
          withExpertiseGroup={user.with_expertise_group}
        />
      )}
      <div className={styles.content}>
        {openedConversation && openedConversation.conversation.is_group_conversation == 1 && !isSender && (
          <p className={styles.userName}>
            {user.status === 'deleted' ? t('global.deletedUser') : `${user.firstname} ${user.lastname}`}
          </p>
        )}
        {messageProp.origin_message && messageProp.has_been_deleted !== 1 && (
          <ReplyingToMessage
            originMessageContainerCSS={styles.originMessageContainerCSS}
            messageObj={{
              message: { id: messageProp.origin_message_id, message: messageProp.origin_message }
            }}
            messageContainerCSS={styles.replyingMessageContainer}
            targetRefs={targetRefs}
          />
        )}
        <ViewMessage
          messageProp={messageProp}
          user={user}
          appendToPrevious={appendToPrevious}
          isLastMessage={isLastMessage}
          isFirstMessage={isFirstMessage}
          lastMessageRef={lastMessageRef}
          firstMessageRef={firstMessageRef}
          setEditMode={setEditMode}
          isMessageAppended={false}
          deleteMessagePopin={deleteMessagePopin}
          showImageModal={showImageModal}
          setEmojiPickerForMessage={setEmojiPickerForMessage}
          unsetEmojiPickerForMessage={unsetEmojiPickerForMessage}
          isNonEmojiPickerMessage={emojiPickerForMessage && emojiPickerForMessage.id !== messageProp.id ? true : false}
          isEmojiPickerOpen={emojiPickerForMessage !== null}
          showTime={true}
          messageTime={messageTime}
          isMobile={isMobile}
          isDesktop={isDesktop}
          showUserModal={showUserModal}
          selectedMessage={selectedMessage}
          setSelectedMessage={setSelectedMessage}
          isSender={isSender}
          isFileProcessing={isFileProcessing}
          targetRefs={targetRefs}
          scrollToTarget={scrollToTarget}
          fromQuickMessenger={fromQuickMessenger}
        />
      </div>
    </div>
  )
}
